angular.module('bribac.views.addGroup', [
  'ngRoute',
  'bribac.entities.kinds',
  'bribac.entities.mainGroupFactory',
  'bribac.entities.subGroupFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.errorUtils',
  'bribac.components.mainGroupEditor',
  'bribac.components.subGroupEditor',
  'bribac.components.whenLoaded'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/add/group', {
      templateUrl: 'add-group-view.html',
      controller: 'AddGroupViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('AddGroupViewCtrl', function(
    $scope,
    KINDS,
    ROLES,
    state,
    mainGroupFactory,
    subGroupFactory,
    api,
    errorUtils,
    permissions
  ) {

    var $ctrl = this

    $ctrl.KINDS = KINDS
    $ctrl.permissions = permissions
    $ctrl.mainGroup = mainGroupFactory()
    $ctrl.subGroup = subGroupFactory()

    $ctrl.mainGroupSelected = function() {
      $ctrl.subGroup.mainGroup = {id: $ctrl.selectedMainGroup.id}
    }

    $ctrl.onSubmit = function($form, kind, entity) {
      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.post(kind, entity)
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(request) {
            if (kind === KINDS.MAIN_GROUP) {
              $ctrl.mainGroups.push(request.data)
              $ctrl.mainGroup = mainGroupFactory()
            } else if (kind === KINDS.SUB_GROUP) {
              $ctrl.mainGroups.forEach(function(mainGroup) {
                if (mainGroup.id === request.data.mainGroup.id) {
                  mainGroup.subGroups.push(request.data)
                }
              })
              $ctrl.subGroup = subGroupFactory({
                mainGroup: {id: $ctrl.selectedMainGroup.id}
              })
            }
            $form.$setPristine()
            $form.$setUntouched()
          },

          function error(request) {
            $form._submitError = errorUtils.parseErrorResponse(request)
          }
        )
    }

    // Init

    $scope.$watch('$ctrl.mainGroup.organization', reloadData)

    function reloadData() {
      $ctrl.selectedMainGroup = null
      var filter = ''

      if ($ctrl.permissions.canManageOrganizations()) {
        if (!$ctrl.mainGroup.organization) {
          return
        } else {
          filter = '?organization=' + $ctrl.mainGroup.organization.id
        }
      }

      $ctrl.mainGroupsPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter).then(function(request) {
        $ctrl.mainGroups = request.data.list
      })
    }

  })
